import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { DialogProps } from '@anyui/core';
import { FormAction } from '@anytag/shared-types';
import { TextField } from '@anytag/shared-molecules';
import { BaseValidations } from '@anytag/shared-validations';
import { BaseModal, Form, ModalBody, ModalFooter } from '@anytag/shared-atoms';

const DuplicateCampaignFormSchema = z.object({ title: BaseValidations.CampaignTitleSchema });
export type DuplicateCampaignFormValues = z.infer<typeof DuplicateCampaignFormSchema>;

export interface DuplicateCampaignModalProps extends Pick<DialogProps, 'open' | 'onClose'> {
  cloning?: boolean;
  onDuplicate: FormAction<DuplicateCampaignFormValues>['onSubmit'];
}

export const DuplicateCampaignModal = ({
  onClose,
  cloning,
  onDuplicate,
  ...restProps
}: DuplicateCampaignModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      onClose={onClose}
      title={t('Modal.Duplicate this Campaign')}
      description={t('Modal.DuplicateCampaignDescription')}
      {...restProps}
      asChild
    >
      <Form.Provider<DuplicateCampaignFormValues> zodSchema={DuplicateCampaignFormSchema} onSubmit={onDuplicate}>
        {({ values }) => (
          <>
            <ModalBody>
              <TextField<keyof DuplicateCampaignFormValues>
                name="title"
                title={t('TextForm.Campaign Title')}
                placeholder={t<string>('TextForm.InstagramCampaign')}
                required
              />
            </ModalBody>

            <ModalFooter
              cancelButton={{ onClick: onClose }}
              submitButton={{
                type: 'submit',
                loading: cloning,
                disabled: !values.title,
                title: t(cloning ? 'Button.Duplicating' : 'Button.Duplicate')
              }}
            />
          </>
        )}
      </Form.Provider>
    </BaseModal>
  );
};
